import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'stringPropertyFilter' } )
export class StringPropertyFilterPipe implements PipeTransform {

	transform( items: any[], searchText: string, property: string ): any[] {
		if ( !items ) {
			return [];
		}
		if ( !searchText ) {
			return items;
		}


		if ( !items.every( itm =>
			Object.keys( itm ).some( key => key === property ) )
		) {
			return [];
		}

		searchText = searchText.toLowerCase();
		return items.filter( it =>
			it[ property ].toLowerCase().search( searchText ) > -1
		);
	}

}

/*
 import { Pipe, PipeTransform } from '@angular/core';

 @Pipe( { name: 'stringPropertyFilter' } )
 export class StringPropertyFilterPipe implements PipeTransform {

 transform( items: any[], searchText: string, property: string ): any[] {

 this.logger.log('items: ', items.length,  ' | ',  JSON.stringify(items) );
 this.logger.log('searchText: ', searchText,  ' | property: ',  property );

 if ( !items ) {
 return [];
 }
 if ( !searchText ) {
 return items;
 }


 const res = items.every( itm =>
 this.checkForExistingKey( itm, property )
 );

 this.logger.log('check outer res: ', res);
 if ( !res ) { return []; }

 return items.filter( itm =>
 itm[ property ].toLowerCase().search( searchText.toLowerCase() ) > -1
 );
 }

 checkForExistingKey( itm, property ) {
 const res = Object.keys( itm ).every( key => key.toLowerCase() === property.toLowerCase() );
 this.logger.log('check inner res: ', res, ' | ', JSON.stringify(itm));
 return res;
 }
 }

 */
